import { FlyoutListMenuWidget, HorizontalOriginOption, MenuButtonWidget,MenuItemInfo, OriginOptions, VerticalOriginOption } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { LinkedTaskDialogStateContext } from './LinkedTaskDialogStateContextProvider';

const buttonStyle: React.CSSProperties = {
  minWidth: 40,
  padding: '0px 8px',
  borderColor: CommonStyles.Colors.Grey203,
};

const bottomLeftOrigin: OriginOptions = {
  horizontal: HorizontalOriginOption.left,
  vertical: VerticalOriginOption.bottom,
};

export type LinkedTaskAddItemBeforeAfterAction = { type: 'addBeforeAfter', payload: { index: number, position: 'before' | 'after' }};

export interface LinkedTaskMoveItemButtonProps {
  index: number;
}

export function LinkedTaskMoveItemButton(props: LinkedTaskMoveItemButtonProps) {
  const [state, dispatch] = React.useContext(LinkedTaskDialogStateContext);
  const [buttonEl, setButtonEl] = React.useState<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const menuId = `move-button-${props.index}`;

  const handleSelect = React.useCallback(value => {
    switch(value) {
      case 'up':
      case 'down':
      case 'beginning':
      case 'end':
        dispatch({ type: 'moveItem', payload: { index: props.index, position: value }});
        break;
      case 'addBefore':
        dispatch({ type: 'addBeforeAfter', payload: { index: props.index, position: 'before' }});
        break;
      case 'addAfter':
        dispatch({ type: 'addBeforeAfter', payload: { index: props.index, position: 'after' }});
        break;
    }
    setIsOpen(false);
  }, [dispatch, props.index]);
  const handleMenuClose = React.useCallback(() => setIsOpen(false), []);
  const handleClick = () => setIsOpen(!isOpen);

  const menuItems: MenuItemInfo[] = [
    { value: 'up', displayValue: Messages.linkedTasksMoveUp() },
    { value: 'down', displayValue: Messages.linkedTasksMoveDown() },
    { value: 'beginning', displayValue: Messages.linkedTasksMoveToBeginning() },
    { value: 'end', displayValue: Messages.linkedTasksMoveToEnd() },
    { isDivider: true },
    { value: 'addBefore', displayValue: Messages.linkedTasksAddTaskBefore() },
    { value: 'addAfter', displayValue: Messages.linkedTasksAddTaskAfter() },
  ];

  return <>
    <MenuButtonWidget
      title={Messages.linkedTasksMoveOrAddItem()}
      aria-controls={menuId}
      children={props.index + 1}
      onClick={handleClick}
      ref={setButtonEl}
      testId={`move-button-id-${props.index}`}
      style={buttonStyle}
      isOpen={isOpen}
      density={'low'}
    />
    {isOpen && <FlyoutListMenuWidget
      anchorEl={buttonEl}
      toggleEl={buttonEl}
      anchorOrigin={bottomLeftOrigin}
      id={menuId}
      menuItemInfos={menuItems}
      onSelect={handleSelect}
      requestCloseAll={handleMenuClose}
      testId={`move-button-menu-id-${props.index}`}
    />}
  </>;
}
